/**
 * The run page of an agent run (spec 2026-10-21-19 §4). Reached from the
 * list (agent-runs/index.tsx), its card, the activity tab and the e-mail. `data.write` or a platform admin (lib/route-permissions.ts).
 */
import { createFileRoute } from '@tanstack/react-router'
import { AgentRunPage, AGENT_RUN_TABS, type AgentRunTab } from '../../../components/agent-runs/AgentRunPage'

interface AgentRunSearch {
    tab?: AgentRunTab
}

export const Route = createFileRoute('/$org/agent-runs/$runUid')({
    validateSearch: (search: Record<string, unknown>): AgentRunSearch => {
        const tab = search.tab
        return typeof tab === 'string' && (AGENT_RUN_TABS as readonly string[]).includes(tab) && tab !== 'summary'
            ? { tab: tab as AgentRunTab }
            : {}
    },
    component: RouteComponent,
})

function RouteComponent() {
    const { org, runUid } = Route.useParams()
    const { tab } = Route.useSearch()
    return <AgentRunPage org={org} runUid={runUid} tab={tab ?? 'summary'} />
}
